import { render, staticRenderFns } from "./ButtonPromise.vue?vue&type=template&id=0b225278&"
import script from "./ButtonPromise.vue?vue&type=script&lang=js&"
export * from "./ButtonPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b225278')) {
      api.createRecord('0b225278', component.options)
    } else {
      api.reload('0b225278', component.options)
    }
    module.hot.accept("./ButtonPromise.vue?vue&type=template&id=0b225278&", function () {
      api.rerender('0b225278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/button/ButtonPromise.vue"
export default component.exports